import React from "react";
import {
  Box,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
  useTheme,
  Link,
  Button
} from "@mui/material";
import ListResponsive from "../../../components/other/ListResponsive";
import {
  BCPArrowUpArrowDown,
  BCPDiceFive,
  BCPFilter,
  BCPLockKeyhole,
  BCPMap,
  BCPSearch,
  BCPSquarePlus,
  BCPXmark
} from "../../../components/icons/bcp/BCPIcons";
import EventCard from "../../../components/layout/EventCard";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import {
  clearFilterSx,
  getFilterSx,
  updateFilters
} from "../../../components/utilities/SortFilterFunctions";
import { normalizeSearch } from "../../../components/utilities/UtilityFunctions";
import ListMap from "../../../components/other/ListMap";
import OptionsMenu from "../../../components/layout/OptionsMenu";
import { ActiveEventsModal } from "../../organize/EventsOrganize/EventsOrganizeDefault";
import InfoContainer from "../../../components/layout/InfoContainer";
import { isAppMode } from "../../../global/AppOverlay";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";

const REQUIRES_ORGANIZER =
  getEnvironmentVariable("REQUIRES_ORGANIZER") === "true";

export default function EventsPlayDefault(props) {
  const {
    loading,
    activeTab,
    handleTabChange,
    a11yProps,
    authContext,
    playersPast,
    playersCurrent,
    playersFollowing,
    filters,
    setFilters,
    filteredEvents,
    setFilteredEvents,
    anchorEl,
    setAnchorEl,
    anchorEl2,
    setAnchorEl2,
    anchorEl3,
    setAnchorEl3,
    toggleMap,
    setToggleMap,
    activeEvents,
    setActiveEvents,
    gameSystems,
    t
  } = props;

  const theme = useTheme();
  const appMode = isAppMode();

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          maxWidth: "100%",
          backgroundColor: "banner.main",
          color: "banner.contrastText",
          borderBottom: 1,
          borderColor: "divider"
        }}
      >
        <Container maxWidth="lg">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="My Events"
          >
            <Tab
              aria-label="Current Events"
              label={t("current")}
              {...a11yProps(0)}
            />
            <Tab aria-label="Past Events" label={t("past")} {...a11yProps(1)} />
            <Tab
              aria-label="Followed Events"
              label={t("following")}
              {...a11yProps(2)}
            />
          </Tabs>
        </Container>
      </Box>
      <Container
        sx={{
          pt: 2,
          pb: 2
        }}
        maxWidth="lg"
      >
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid item xs={12}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              {t("myEvents")}
            </Typography>
          </Grid>

          {Boolean(
            NO_SUBSCRIPTIONS ||
              authContext?.authState?.identity?.subscriber ||
              authContext?.authState?.identity?.isAdmin ||
              activeTab === 0 ||
              activeTab === 2
          ) && (
            <Grid item xs={12}>
              {!loading &&
              !filteredEvents &&
              ((activeTab === 0 && !playersCurrent?.length) ||
                (activeTab === 1 && !playersPast?.length) ||
                (activeTab === 2 && !playersFollowing?.length)) ? (
                <InfoContainer
                  title={`${t("no")} ${t(
                    activeTab === 0
                      ? "current"
                      : activeTab === 1
                        ? "past"
                        : "following"
                  )?.toLowerCase()} ${t("eventsFound")}`}
                  body={`${t("noEventsFound", {
                    tab: t(
                      activeTab === 0
                        ? "current"
                        : activeTab === 1
                          ? "past"
                          : "following"
                    )?.toLowerCase()
                  })} ${
                    activeTab === 2
                      ? t("howToFollow")
                      : activeTab === 1
                        ? t("eventsWillAppearHere")
                        : t("createOrSearchForEvents")
                  }`}
                  ActionButton={
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                        justifyContent: "center"
                      }}
                    >
                      {activeTab === 0 &&
                        (!REQUIRES_ORGANIZER ||
                          authContext?.authState?.identity?.isAdmin === true ||
                          authContext?.authState?.identity?.isJudge ||
                          authContext?.authState?.identity?.isOrganizer) && (
                          <Button
                            variant="contained"
                            href="/organize/event"
                            target={`${appMode ? "_blank" : "_self"}`}
                            startIcon={<BCPSquarePlus />}
                          >
                            {t("createEvent", {
                              keyPrefix: "pages.dashboards.play"
                            })}
                          </Button>
                        )}
                      <Button
                        variant={activeTab === 0 ? "outlined" : "contained"}
                        href="/play/events"
                        target={`${appMode ? "_blank" : "_self"}`}
                        startIcon={<BCPSearch />}
                      >
                        {t("searchForEvents")}
                      </Button>
                    </Box>
                  }
                />
              ) : (
                <ListResponsive
                  originalList={
                    loading
                      ? null
                      : filteredEvents !== null
                        ? filteredEvents
                        : activeTab === 1 && playersPast?.length
                          ? playersPast
                          : activeTab === 2 && playersFollowing?.length
                            ? playersFollowing
                            : activeTab === 0 && playersCurrent?.length
                              ? playersCurrent
                              : null
                  }
                  doSearch
                  actionButtonBottom={[
                    {
                      label: t("sort", {
                        keyPrefix: "buttons"
                      }),
                      startIcon: <BCPArrowUpArrowDown />,
                      onClick: (e) => {
                        setAnchorEl(e.currentTarget);
                      },
                      disabled:
                        loading ||
                        (activeTab === 0 && !playersCurrent?.length) ||
                        (activeTab === 1 && !playersPast?.length) ||
                        (activeTab === 2 && !playersFollowing?.length),
                      sx: {
                        ...getFilterSx(
                          Boolean(
                            filters.length &&
                              filters.some((item) => item.includes("sort"))
                          ),
                          filters,
                          theme
                        )
                      }
                    },
                    {
                      label: t("filters", {
                        keyPrefix: "buttons"
                      }),
                      startIcon: <BCPFilter />,
                      onClick: (e) => {
                        setAnchorEl2(e.currentTarget);
                      },
                      disabled:
                        loading ||
                        (activeTab === 0 && !playersCurrent?.length) ||
                        (activeTab === 1 && !playersPast?.length) ||
                        (activeTab === 2 && !playersFollowing?.length),
                      sx: {
                        ...getFilterSx(
                          Boolean(
                            filters.length &&
                              filters.some((item) => item.includes("filter"))
                          ),
                          filters,
                          theme
                        )
                      }
                    },
                    getEnvironmentVariable("SINGLE_GAME_SYSTEM") !== "true" &&
                      getEnvironmentVariable("SINGLE_GAME_MANUFACTURER") !==
                        "true" && {
                        label: t("gameSystems", {
                          keyPrefix: "buttons"
                        }),
                        startIcon: <BCPDiceFive />,
                        disabled:
                          loading ||
                          loading ||
                          (activeTab === 0 && !playersCurrent?.length) ||
                          (activeTab === 1 && !playersPast?.length) ||
                          (activeTab === 2 && !playersFollowing?.length) ||
                          !gameSystems?.length,
                        onClick: (e) => {
                          setAnchorEl3(e.currentTarget);
                        },
                        sx: {
                          ...getFilterSx(
                            Boolean(
                              filters.length &&
                                filters.some((item) =>
                                  item.includes("gamesystem")
                                )
                            ),
                            filters,
                            theme
                          )
                        }
                      },
                    {
                      label: t("toggleMap", {
                        keyPrefix: "buttons"
                      }),
                      startIcon: <BCPMap />,
                      onClick: (e) => {
                        setToggleMap(!toggleMap);
                      },
                      disabled:
                        loading ||
                        (activeTab === 0 && !playersCurrent?.length) ||
                        (activeTab === 1 && !playersPast?.length) ||
                        (activeTab === 2 && !playersFollowing?.length),
                      sx: {
                        ...getFilterSx(!loading && toggleMap, filters, theme)
                      }
                    },
                    {
                      label: t("clearFilters", {
                        keyPrefix: "buttons"
                      }),
                      startIcon: <BCPXmark />,

                      disabled:
                        loading ||
                        (activeTab === 0 && !playersCurrent?.length) ||
                        (activeTab === 1 && !playersPast?.length) ||
                        (activeTab === 2 && !playersFollowing?.length),
                      sx: {
                        ...clearFilterSx(false, filters, theme)
                      },
                      onClick: () => {
                        updateFilters(null, null, null, setFilters);
                        setFilteredEvents(null);
                        setToggleMap(true);
                        setActiveEvents(null);
                        setAnchorEl(null);
                        setAnchorEl2(null);
                        setAnchorEl3(null);
                      }
                    }
                  ]}
                  searchProps={{
                    label: t("searchEvents", {
                      keyPrefix: "pages.dashboards.play"
                    }),
                    performSearch: (originalList, searchText) => {
                      if (!searchText || searchText === "") {
                        return originalList;
                      } else {
                        const normalizedText = normalizeSearch(searchText);
                        var filteredList = originalList.filter(function (el) {
                          if (normalizeSearch(el?.eventLocation).includes(normalizedText))
                            return true;
                          if (normalizeSearch(el?.name).includes(normalizedText))
                            return true;
                          if (normalizeSearch(el?.gameSystem?.name).includes(normalizedText))
                            return true;
                          return false;
                        });
                        return filteredList;
                      }
                    }
                  }}
                  scrollToTop
                  centerNav
                  doPages
                  initialRowsPerPage={24}
                  rowsPerPageArray={[
                    12,
                    24,
                    48,
                    96,
                    { label: "All", value: -1 }
                  ]}
                  rowProps={{
                    mapFunction: (row, index) => (
                      <Grid
                        key={index}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{ p: 1 }}
                      >
                        <EventCard
                          event={row}
                          key={row?.id || index}
                          preventImageFetch
                        />
                      </Grid>
                    )
                  }}
                >
                  {toggleMap && !loading && (
                    <Box sx={{ mt: [0, 2] }}>
                      <ListMap
                        name="events-map"
                        originalList={
                          filteredEvents !== null
                            ? filteredEvents.filter(
                                (event) => !event?.isOnlineEvent
                              )
                            : activeTab === 1 && playersPast?.length
                              ? playersPast.filter(
                                  (event) => !event?.isOnlineEvent
                                )
                              : activeTab === 2 && playersFollowing?.length
                                ? playersFollowing.filter(
                                    (event) => !event?.isOnlineEvent
                                  )
                                : activeTab === 0 && playersCurrent?.length
                                  ? playersCurrent.filter(
                                      (event) => !event?.isOnlineEvent
                                    )
                                  : null
                        }
                        zoom={10}
                        sx={{ mb: 1 }}
                        mapSx={{ height: "30vh" }}
                        defaultCenter={
                          filteredEvents?.length
                            ? {
                                lat: filteredEvents?.[0]?.coordinate?.[1],
                                lng: filteredEvents?.[0]?.coordinate?.[0]
                              }
                            : activeTab === 1 && playersPast?.length
                              ? {
                                  lat: playersPast?.[0]?.coordinate?.[1],
                                  lng: playersPast?.[0]?.coordinate?.[0]
                                }
                              : activeTab === 2 && playersFollowing?.length
                                ? {
                                    lat: playersFollowing?.[0]?.coordinate?.[1],
                                    lng: playersFollowing?.[0]?.coordinate?.[0]
                                  }
                                : activeTab === 0 && playersCurrent?.length
                                  ? {
                                      lat: playersCurrent?.[0]?.coordinate?.[1],
                                      lng: playersCurrent?.[0]?.coordinate?.[0]
                                    }
                                  : null
                        }
                        onClick={(lat, lng) => {
                          const eventArr = [];
                          const events = filteredEvents
                            ? filteredEvents
                            : activeTab === 1 && playersPast?.length
                              ? playersPast
                              : activeTab === 2 && playersFollowing?.length
                                ? playersFollowing
                                : playersCurrent;
                          events.forEach((event) => {
                            if (
                              event?.coordinate?.[0] === lng &&
                              event?.coordinate?.[1] === lat
                            ) {
                              eventArr.push(event);
                            }
                          });

                          setActiveEvents(eventArr);
                        }}
                        filterFunction={(event) =>
                          !event?.isOnlineEvent &&
                          (event?.coordinate?.length ||
                            event?.coordinate_point?.coordinates?.length) &&
                          (event?.coordinate[0] ||
                            event?.coordinate_point?.coordinates[0]) &&
                          (event?.coordinate[1] ||
                            event?.coordinate_point?.coordinates[1])
                        }
                      />
                    </Box>
                  )}
                </ListResponsive>
              )}
            </Grid>
          )}

          {/* Sorting */}
          <OptionsMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            items={[
              {
                name: "sort-date-asc",
                label: t("startDateAscending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-date-asc"),
                onClick: () =>
                  updateFilters("sort-date-asc", false, filters, setFilters)
              },
              {
                name: "sort-date-desc",
                label: t("startDateDescending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-date-desc"),
                onClick: () =>
                  updateFilters("sort-date-desc", false, filters, setFilters)
              },
              {
                name: "sort-name-asc",
                label: t("nameAscending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-name-asc"),
                onClick: () =>
                  updateFilters("sort-name-asc", false, filters, setFilters)
              },
              {
                name: "sort-name-desc",
                label: t("nameDescending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-name-desc"),
                onClick: () =>
                  updateFilters("sort-name-desc", false, filters, setFilters)
              },
              {
                name: "sort-rounds-asc",
                label: t("roundsAscending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-rounds-asc"),
                onClick: () =>
                  updateFilters("sort-rounds-asc", false, filters, setFilters)
              },
              {
                name: "sort-rounds-desc",
                label: t("roundsDescending", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("sort-rounds-desc"),
                onClick: () =>
                  updateFilters("sort-rounds-desc", false, filters, setFilters)
              }
            ]}
            name="events-sort-menu"
          />

          {/* Filters */}
          <OptionsMenu
            anchorEl={anchorEl2}
            setAnchorEl={setAnchorEl2}
            items={[
              {
                name: "filter-online",
                label: t("onlineEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-online"),
                onClick: () =>
                  updateFilters(
                    "filter-online",
                    "filter-exclude-online",
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-exclude-online",
                label: t("excludeOnline", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-exclude-online"),
                onClick: () =>
                  updateFilters(
                    "filter-exclude-online",
                    "filter-online",
                    filters,
                    setFilters
                  )
              },
              { divider: true },

              {
                name: "filter-org",
                label: t("gameStoreEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-org"),
                onClick: () =>
                  updateFilters(
                    "filter-org",
                    "filter-exclude-org",
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-exclude-org",
                label: t("excludeGameStoreEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-exclude-org"),
                onClick: () =>
                  updateFilters(
                    "filter-exclude-org",
                    "filter-org",
                    filters,
                    setFilters
                  )
              },
              { divider: true },

              {
                name: "filter-singles",
                label: t("singlesEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-singles"),
                onClick: () =>
                  updateFilters(
                    "filter-singles",
                    ["filter-doubles", "filter-teams", "filter-board"],
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-doubles",
                label: t("doublesEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-doubles"),
                onClick: () =>
                  updateFilters(
                    "filter-doubles",
                    ["filter-singles", "filter-teams", "filter-board"],
                    filters,
                    setFilters
                  )
              },
              {
                name: "filter-teams",
                label: t("teamsEvents", {
                  keyPrefix: "fields"
                }),
                selected: filters.includes("filter-teams"),
                onClick: () =>
                  updateFilters(
                    "filter-teams",
                    ["filter-singles", "filter-doubles", "filter-board"],
                    filters,
                    setFilters
                  )
              }
            ]}
            name="events-filter-menu"
          />

          {/* Game Systems */}
          {gameSystems?.length && (
            <OptionsMenu
              anchorEl={anchorEl3}
              setAnchorEl={setAnchorEl3}
              items={gameSystems.map((gameSystem) => ({
                name: `gamesystem-${gameSystem?.id}`,
                label: gameSystem.name,
                selected: filters.includes(`gamesystem-${gameSystem?.id}`),
                onClick: () =>
                  updateFilters(
                    `gamesystem-${gameSystem?.id}`,
                    false,
                    filters,
                    setFilters
                  )
              }))}
              name="gamesystem-menu"
            />
          )}

          {activeEvents?.length && (
            <ActiveEventsModal
              activeEvents={activeEvents}
              setActiveEvents={setActiveEvents}
            />
          )}
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
            }}
          >
            {!NO_SUBSCRIPTIONS &&
              !authContext?.authState?.identity?.subscriber &&
              activeTab === 1 && (
                <Grid container>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <BCPLockKeyhole
                      sx={{
                        fontSize: 150,
                        color: theme.palette.text.disabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Typography variant="body1" paragraph>
                      {t("youAreRegisteredFor", {
                        count: playersPast?.length || "-"
                      })}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {t("nonSubscriber")}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {t("unlimitedHistory")}{" "}
                      <Link href="/subscription" underline="none">
                        {t("here")}
                      </Link>
                      .
                    </Typography>
                  </Grid>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
